import {CtaBanner, type CtaBannerProps} from '../../generic/CtaBanner/CtaBanner'
import {MonaDivider, type MonaDividerProps} from '../../generic/MonaDivider/MonaDivider'

import Styles from './CtaBannerSection.module.css'

export interface CtaBannerSectionProps {
  monaDivider: MonaDividerProps
  ctaBanner: CtaBannerProps
}

export type CtaBannerSectionPropsData = Omit<CtaBannerSectionProps, 'monaDivider'>

export const defaultProps: Partial<CtaBannerSectionProps> = {}

export const CtaBannerSection = (props: CtaBannerSectionProps) => {
  const initializedProps: CtaBannerSectionProps = {...defaultProps, ...props}
  const {monaDivider, ctaBanner} = initializedProps

  return (
    <div className={Styles['CtaBannerSection']}>
      <MonaDivider {...monaDivider} />
      <CtaBanner {...ctaBanner} />
    </div>
  )
}
